 document.addEventListener('DOMContentLoaded', function() {
    const currencysmy = (currency, locale) =>
    new Intl.NumberFormat(locale, { style: 'currency', currency })
        .formatToParts(1)
        .find(x => x.type === "currency")
        .value;
    const currencysymbol = currencysmy(window.ShopifyAnalytics.meta.currency, window.ShopifyAnalytics.meta.locale);
    var shown = false;

    function fetchCart(callback) {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                if (cart.items.length > 0) {
                    var firstItem = cart.items[0];
                    
                    if (firstItem.handle === 'heart-shaped-foil-shopper-bag-rose-gold-by-goddiva') {
                        return; // Do NOT show popup
                    }
                    callback(firstItem);
                }
            });
    }

    function showFirstAddedItem(item) {
        var productImageDiv = document.querySelector('.product-image img');
        var productTitleDiv = document.querySelector('.product-title');
        var productPriceDiv = document.querySelector('.product-price');

        productImageDiv.setAttribute('src', item.featured_image.url);
        productImageDiv.setAttribute('alt', item.title);
        productImageDiv.setAttribute('height', item.featured_image.height);
        productImageDiv.setAttribute('width', item.featured_image.width);

        productTitleDiv.innerHTML = `<p>${item.product_title}</p>`;
        productPriceDiv.innerHTML = `<p>${currencysymbol}${item.price / 100}</p>`;

        document.querySelector('#cart-exit-intent').classList.add('show');
        document.querySelector('body').classList.add('modal-open');
        document.querySelector('.modal-backdrop').classList.add('show');

        document.querySelector('.cart-intent-close').addEventListener('click', function() {
            document.querySelector('#cart-exit-intent').classList.remove('show');
            setTimeout(() => {
                document.querySelector('body').classList.remove('modal-open');
                document.querySelector('.modal-backdrop').classList.remove('show');
            }, 200);
            // Set the current time in localStorage when the popup is closed
            localStorage.setItem('cartIntentPopupClosedTime', Date.now());
        });
    }

    function handleMouseOut(event) {
        if (event.clientY <= 0 && !shown) {
            shown = true;
            fetchCart(showFirstAddedItem);
        }
    }
    var pageVisits = localStorage.getItem('cartIntentPageVisits') || 0;
    pageVisits++;
    localStorage.setItem('cartIntentPageVisits', pageVisits);

    var popupClosedTime = localStorage.getItem('cartIntentPopupClosedTime');
    var sevenDaysInMillis = 7 * 24 * 60 * 60 * 1000;

    if (pageVisits >= 2) {
        if (!popupClosedTime || (Date.now() - popupClosedTime) > sevenDaysInMillis) {
            document.addEventListener('mouseout', handleMouseOut);
        }
    }
});